<template>
  <div>
    <progress-bar :step="1" />
    <loading-screen v-if="isLoading" />
    <div class="m-t-24">
      <h2 class="text-center mb-4">
        <strong>Pago de Factura</strong>
      </h2>

      <ul
        v-for="service in invoicesMcw"
        :key="service.serviceId"
      >
        <li>
          <p class="bold px-2 my-2">
            {{ service.serviceId | formatPhone }}
          </p>
          <hr />
          <template v-if="service.isValid">
            <ul
              v-if="service.pendingInvoices.length > 0"
            >
              <li
                v-for="(invoice, index) in service.pendingInvoices"
                :key="index"
                class="invoice-container"
              >
                <label class="flex items-center invoice">
                  <div class="grid flex-grow">
                    <span class="bold w-full mb-0">
                      Saldo de factura {{ isDued(invoice) ? "vencida" : "por vencer" }}
                    </span>
                    <div class="flex">
                      <span
                        class="bold"
                        name="amount"
                        :class="{ 'text-red': isDued(invoice) }"
                      >
                        {{ country.money }}{{ invoice.dueAmount | toFixed }}
                      </span>

                      <span
                        class="ml-4 text-center"
                        name="dueDate"
                      >{{ invoice.dueDate | local }}
                      </span>
                    </div>
                  </div>

                  <input
                    v-if="!invoice.isProcessing"
                    :id="invoice.id"
                    v-model="invoicesSelected"
                    name="some-radios"
                    :value="{
                      serviceId: service.serviceId,
                      ...invoice
                    }"
                    class="checkbox"
                    type="checkbox"
                  />
                  <p
                    v-else
                    class="bold pb-0 mb-0 text-red"
                  >
                    Pago en proceso
                  </p>
                </label>
              </li>
            </ul>
            <h4
              v-else-if="!service.isRecurrent"
              class="text-center m-t-8"
              name="no bills"
            >
              {{ $t('text.noInvoicesNow') }}
            </h4>
            <h4
              v-if="service.isRecurrent"
              class="text-left m-t-8"
            >
              Pago recurrente activo
            </h4>
          </template>
          <h4
            v-else
            class="text-center m-t-8"
          >
            No es posible mostrar esta información
          </h4>
        </li>
      </ul>
      <div>
        <p class="mb-0 bold">
          Total
        </p>
        <hr />
        <p class="bold">
          {{ country.money }}{{ totalRecords | toFixed }}
        </p>
      </div>

      <div class="flex justify-around gap-4">
        <button
          class="button back"
          :class="buttonClass"
          @click="backToIframe()"
        >
          Regresar al inicio
        </button>

        <button
          v-if="validateInvoices"
          class="button bg-black"

          :disabled="invoicesSelected.length === 0"
          @click="processInvoice"
        >
          Pagar Factura
        </button>
      </div>
      <popup
        v-if="payDuedInvoices"
        @back="payDuedInvoices = false"
      />
    </div>
  </div>
</template>

<script>
import jwt from 'jwt-decode';
import storage from '@lagersoft/key-storage';
import { mapActions, mapGetters } from 'vuex';
import {
  MPC,
  MCE,
  MCW
} from '@/utils/constants';
import { mixinPushInvoicesErrorRoute } from '@/mixins/errorMixins';
import Popup from '../common/Components/PayFirstDueInvoices';
import ProgressBar from './Components/ProgressBar';

export default {
  name: 'Payment',
  components: {
    Popup,
    ProgressBar
  },
  mixins: [mixinPushInvoicesErrorRoute],
  data() {
    return {
      payDuedInvoices: false,
      isLoading: false,
      error: false,
      selected: null,
      isError: '',
      invoicesSelected: [],
      totalRecords: 0
    };
  },
  computed: {
    ...mapGetters([
      'app',
      'invoicesMcw',
      'pack',
      'country'
    ]),
    buttonClass() {
      switch (this.app) {
        case MCE:
          return 'button--red button--bubble button--flex';
        case MPC:
          return 'grey-button';
        case MCW:
          return MCW.toLowerCase();
        default:
          return '';
      }
    },
    msisdn() {
      return jwt(storage.get('tokenIvr')).msisdn;
    },
    token() {
      return jwt(storage.get('tokenIvr'));
    },
    validateInvoices() {
      const validation = [];
      if (Array.isArray(this.invoicesMcw)) {
        this.invoicesMcw.forEach((elem) => {
          if (elem.pendingInvoices.length > 0) {
            validation.push(true);
          } else {
            validation.push(false);
          }
        });
      } else if (this.invoicesMcw.pendingInvoices.length > 0) {
        validation.push(true);
      } else {
        validation.push(false);
      }
      return validation.some((elem) => elem);
    }
  },
  watch: {
    invoicesSelected: {
      deep: true,
      handler(val) {
        this.calculateTotal(val);
      }
    }
  },
  created() {
    // global.api.getInvoicePaymentsIFrameToken().then(res => {
    // storage.set('tokenMCW', res.data.t)
    // })
    // this.isLoading = true;
    this.getInvoices();
  },
  methods: {
    ...mapActions([
      'setInvoicesMcw'
    ]),
    backToIframe() {
      window.parent.postMessage({
        hook: 'onBack'
      }, '*');
    },
    getInvoices() {
      this.isLoading = true;
      global.api.mcwGetInvoices().then((res) => {
        this.isLoading = false;
        this.setInvoicesMcw(res.data);
      }).catch((err) => {
        this.isLoading = false;
        this.pushInvoicesErrorRoute(err); // mixin
      });
    },
    calculateTotal(val) {
      let total = 0;
      if (val.length > 0) {
        val.forEach((invoice) => {
          total += invoice.dueAmount;
        });
      }
      this.totalRecords = total;
    },
    processInvoice() {
      this.isLoading = true;
      const paymentObject = {};
      if (this.invoicesSelected.length > 0) {
        this.invoicesSelected.forEach((invoice) => {
          if (paymentObject[invoice.serviceId]) {
            paymentObject[invoice.serviceId].push(...invoice.reference);
          } else {
            paymentObject[invoice.serviceId] = [...invoice.reference];
          }
        });
      }
      let invoiceCount = 0;
      this.invoicesMcw.forEach((service) => {
        service.pendingInvoices.forEach((invoice) => {
          if (!invoice.isProcessing) {
            invoiceCount++;
          }
        });
      });
      if (this.invoicesSelected.length !== invoiceCount) {
        if (this.stillOwesAnOlderInvoice()) {
          this.payDuedInvoices = true;
          this.isLoading = false;
          return;
        }
      }
      global.api.mcwPostPayment(paymentObject).then((res) => {
        this.isLoading = false;
        window.location.href = `${res.data}&isStage=true`;
      }).catch((err) => {
        this.isLoading = false;
        this.$router.push({ name: 'ErrorMCW', query: { error: 'GENERIC_ERROR', desc: err } });
      });
    },
    stillOwesAnOlderInvoice() {
      const pendingInvoices = this.invoicesMcw.reduce(
        (acc, service) => acc.concat(service.pendingInvoices), []
      );

      const selectedInvoices = this.invoicesSelected;
      const duedInvoices = (invoices) => invoices.filter(this.isDued);

      const notSelectedInvoices = pendingInvoices.filter(
        (invoice) => !selectedInvoices?.some((elem) => elem.id === invoice.id)
      );

      const duedInvoicesNotSelected = duedInvoices(notSelectedInvoices);

      if (duedInvoicesNotSelected.length === 0) {
        return false;
      }

      const oldestInvoice = (invoices) => invoices?.reduce(
        (prev, current) => (new Date(prev?.dueDate) < new Date(current?.dueDate) ? prev : current)
      );

      const newerInvoice = (invoices) => invoices?.reduce(
        (prev, current) => (new Date(prev?.dueDate) > new Date(current?.dueDate) ? prev : current)
      );

      const oldestDuedInvoiceNotSelected = oldestInvoice(duedInvoicesNotSelected);
      const newestInvoiceSelected = newerInvoice(selectedInvoices);

      const { dueDate: oldestDuedDate } = oldestDuedInvoiceNotSelected;
      const { dueDate: newestInvoiceSelectedDueDate } = newestInvoiceSelected;
      return new Date(oldestDuedDate) < new Date(newestInvoiceSelectedDueDate);
    },
    isDued(invoice) {
      const dueDate = new Date(invoice.dueDate);
      return dueDate < new Date();
    }
  }

};
</script>

<style scoped lang="scss">
ul {
    list-style: none;
    padding: 0;
}
hr {
    margin: 0;
}

.button {
    font-size: 1.25rem;
    width: auto;
    text-align: center;
    border-radius: 0;
    font-weight: normal;
    text-transform: uppercase;
}

.button[disabled] {
    opacity: 0.6;
}

@media only screen and (max-width: 600px) {
  .button {
      font-size: 14px;
  }
}

.back {
    background-color: #AF272F;
}

.invoice {
  padding: 1rem;
  margin: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
